import {
    setInsuranceActiveContractor,
    setLeaseActiveContractor,
    setShowContactorNotice,
} from "../vehicleInformationSlice";
import { updateDossier } from "../../../app/rootReducer";
import { PatchStepsEnum } from "../../../common/constants/PatchStepsEnum";
import { AppDispatch } from "../../../app/store";
import { ContractorEnum } from "../../../common/constants/ContractorEnum";

interface Props {
    dispatch: AppDispatch;
    type: ContractorEnum;
}

export const handleContractorBack = (props: Props): void => {
    const { dispatch, type } = props;

    switch (type) {
        case ContractorEnum.LEASE:
            dispatch(setLeaseActiveContractor(null));
            break;
        case ContractorEnum.INSURANCE:
            dispatch(setInsuranceActiveContractor(null));
            break;
    }

    dispatch(
        updateDossier({
            data: { contractor_id: null },
            method: PatchStepsEnum.PatchContractor,
        }),
    );
    dispatch(setShowContactorNotice(false));
};
